import { ExchangeRefundModalData } from '@entities/order';
import { ActionModalTypes, SET_MODAL, CLOSE_MODAL } from './actions';

const initialState: ExchangeRefundModalData = null;

function loadingReducer(state = initialState, { type, payload }: ActionModalTypes) {
	switch (type) {
		case SET_MODAL: {
			return payload;
		}

		case CLOSE_MODAL: {
			return null;
		}

		default: {
			return state;
		}
	}
}

export default loadingReducer;
